module.exports = __webpack_public_path__ + "static/media/arrowclose.68aecbd6.svg";